export function HiddenList(hiddenElement) {
    this.hiddenElement = hiddenElement;
    this.options = {};
    this.isMultiple = this.hiddenElement.dataset.multiple === "true";

    this.selectItem = function (value) {
        if (this.isMultiple) {
            if (!this.isSelected(value)) {
                const selection = this.getSelection();
                selection.push(value);
                this.hiddenElement.value = selection.join(',');
                return true;
            }
        } else {
            this.hiddenElement.value = value;
            return true;
        }

        return false;
    };

    this.deselectItem = function (value) {
        const selection = this.getSelection();
        for (let i = 0; i < selection.length; i++) {
            if (selection[i] === value) {
                selection.splice(i, 1);
                break;
            }
        }

        this.hiddenElement.value = selection.join(',');
    };

    this.clearSelection = function () {
        this.hiddenElement.value = '';
    };

    this.isSelected = function (value) {
        const selection = this.getSelection();
        for (let i = 0; i < selection.length; i++) {
            if (selection[i] === value) {
                return true;
            }
        }

        return false;
    };

    this.getSelectionString = function () {
        return this.hiddenElement.value;
    };

    this.getSelection = function () {
        const selStr = this.hiddenElement.value;
        if (selStr) {
            return this.hiddenElement.value.split(',');
        }
        return [];
    };

    this.setOptions = function (selection, options) {
        let i;
        // clear the list of all options, except for those that are selected.
        for (const prop in this.options) {
            let found = false;
            for (i = 0; i < selection.length; i++) {
                if (prop === selection[i]) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                delete this.options[prop];
            }
        }

        for (i = 0; i < options.length; i++) {
            const opt = options[i];
            this.options[opt.value] = {
                value: opt.value,
                label: opt.label
            };
        }
    };

    this.getOptions = function () {
        return this.options;
    };

    this.getOptionsForSelection = function () {
        const opts = [];
        const selection = this.getSelection();
        for (let i = 0; i < selection.length; i++) {
            opts.push(this.options[selection[i]]);
        }

        return opts;
    };

    this.dispatchChangeEvent = function () {
        const event = document.createEvent('Event');
        event.initEvent('change', false, false);
        this.hiddenElement.dispatchEvent(event);
    };
}